import { render } from "./CorporateDirectory.vue?vue&type=template&id=71390291&scoped=true"
import script from "./CorporateDirectory.vue?vue&type=script&lang=js"
export * from "./CorporateDirectory.vue?vue&type=script&lang=js"

import "./corporate-directory.scss?vue&type=style&index=0&id=71390291&lang=scss&scoped=true"
import "./CorporateDirectory.vue?vue&type=style&index=1&id=71390291&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71390291"]])

export default __exports__